<template>
  <div id="alertModal" class="modal fade" :class="show ? 'show' : 'hide'">
    <div class="modal-dialog">
      <div class="modal-content">
        <h4 class="modal-title"><img src="../../assets/image/error.png" alt="" /></h4>
        <div class="modal-body">{{ text }}</div>
        <button type="button" class="close" @click="destroyVm">
          <img src="../../assets/image/icon-close.png" alt="" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      show: false,
    };
  },
  methods: {
    init() {
      this.show = true;
    },
    destroyVm() {
      this.show = false;
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
  background: rgba(0, 22, 53, 0.6);
  &.show {
    display: block;
    animation: fadeIn 0.15s linear;
  }
  &.hide {
    display: none;
  }
  .modal-dialog {
    width: auto;
    position: relative;
    transform: translateY(-50%);
    top: 50%;
    margin: 0 auto;
    padding: 0 10px;
  }
  .modal-title {
    width: 100%;
    text-align: center;
    color: #fff;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 40px;
    font-style: italic;
    margin-bottom: 20px;
    img {
      width: 50px;
    }
  }
  .modal-content {
    min-height: 260px;
    background: url("../../assets/image/login-bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .modal-body {
      font-size: 14px;
      color: #f554b2;
      text-align: center;
      padding: 0;
      flex: unset;
    }
    .close {
      position: absolute;
      top: -2%;
      right: 3%;
      width: 30px;
      opacity: 1;
      padding: 0;
      font-style: italic;
      font-size: 30px;
      font-weight: 700;
      z-index: 1;
      background: transparent;
      cursor: pointer;
      outline: none;
    }
  }
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 400px;
  }
}
</style>
